import { createContext, useContext, useState, useEffect } from "react";
import { authenticateAndFetchUserDetails } from "../services/crmServices/loginService";
import { toast } from "sonner";
import { getUserDataById } from "../services/crmServices/userService";

const AuthContext = createContext(undefined);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [checkedAuth, setCheckedAuth] = useState(false);

    // Check for stored auth on mount
    useEffect(() => {
        const storedUserJSON = localStorage.getItem("crm_user");
        if (storedUserJSON) {
            const storedUser = JSON.parse(storedUserJSON);
            getUserDataById(storedUser._id)
                .then((res) => {
                    if (res.status === 200 && res.data) {
                        const apiUser = { token: storedUser.token, ...res.data };
                        setUser(apiUser);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching user:", err);
                })
                .finally(() => {
                    setCheckedAuth(true);
                });
        } else {
            setCheckedAuth(true);
        }
    }, []);

    const login = async (email, password) => {
        authenticateAndFetchUserDetails(email, password).then((response) => {
            const userInfo = response.data;
            if (userInfo === "password_incorrect") {
                toast.warning("Incorrect password. Please try again.");
            } else if (userInfo === "user_name_incorrect") {
                toast.warning("Incorrect username. Please try again.");
            } else if (userInfo === "user_not_confirmed") {
                toast.warning("User account is not confirmed. Please contact support.");
            } else if (userInfo === "user_deactivated") {
                toast.warning("User account is deactivated. Please contact support.");
            } else if (userInfo.user && userInfo.token) {
                toast.success("Login successful!");
                const userData = { ...userInfo.user, token: userInfo.token };
                setUser(userData);
                localStorage.setItem("crm_user", JSON.stringify(userData));
            } else {
                toast.warning("Invalid credentials.");
                throw new Error("Invalid credentials");
            }
        });
    };

    const fastLogin = (userData) => {
        setUser(userData);
        localStorage.setItem("crm_user", JSON.stringify(userData));
    };

    const updateProfile = (userData) => {
        setUser(userData);
        localStorage.setItem("crm_user", JSON.stringify(userData));
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem("crm_user");
    };

    return (
        <AuthContext.Provider
            value={{ user, login, fastLogin, updateProfile, logout, isAuthenticated: !!user, checkedAuth }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
